import { useInfiniteQuery } from '@tanstack/react-query';
import api from '../../services/api';

interface Params {
    startDate: string;
    endDate: string;
    totemId: string | undefined;
}

export interface ResponseLogsErrorsTotem {
    payload: Payload;
    timestamp: string;
    severity: string;
    insertId: string;
    receivedAt: string;
}

export interface Payload {
    message: string;
    date: string;
    error: string;
    isInternal: boolean;
    totemId: number;
    subtitle: string;
    androidUid: string;
    deviceId: string;
    title: string;
    storeId: number;
}

export function useGetLogsErrorsTotem(params: Params) {
    const getLogsErrorsTotem = async (pageToken: string) => {
        const {
            data,
        }: {
            data: { data: ResponseLogsErrorsTotem[]; nextPageToken: string };
        } = await api.get('/totem/gcp-logs', {
            params: {
                ...params,
                pageToken,
            },
        });

        return {
            data: data.data,
            nextPageToken: data.nextPageToken,
        };
    };

    return useInfiniteQuery({
        queryKey: ['GET_LOGS_ERRORS_TOTEM', params],
        queryFn: ({ pageParam = '' }) => getLogsErrorsTotem(pageParam),
        refetchOnWindowFocus: false,
        enabled: !!params.totemId && !!params.startDate && !!params.endDate,
        getNextPageParam: (lastPage) => {
            if (lastPage.nextPageToken) {
                return lastPage.nextPageToken;
            }
            return undefined;
        },
    });
}
